import React from "react";
import Nav from "./Nav";
import Ichola from "./ichola";
import ImageCarousel from "./ImageCarousel";

export default function HeaderPackage() {
  return (
    <div className="bg-[#a70000] md:bg-inherit">
     
      <div className="flex flex-col-reverse md:flex-col pt-[62px]">
        <ImageCarousel />
        <Ichola />
      </div>
    </div>
  );
}
